<template>
  <div id="insurance-order-nav">

    <!-- 面包屑导航 -->
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/insurances'">旅游保险</router-link>
      <div class="bread-arrow">&gt;</div>
      <div class="bread-item bread-ellipsis">{{insuranceName}}</div>
    </div>

    <!-- 保险进度 -->
    <div class="insurance-schedule">
      <div class="schedule-item" :class="{'active': index + 1 === insuranceSchedule}"
        v-for="(item, index) in scheduleBox" :key="index" >
        <div class="item-num">{{index + 1}}</div>
        <div class="item-content">{{item}}</div>
      </div>
      <div class="schedule-line"></div>
    </div>

  </div>
</template>

<script>

export default {
  props: {
    insuranceName: {
      type: String,
      default: '',
      required: true,
    },
    insuranceSchedule: {
      type: Number,
      default: 1,
      required: true,
    },
  },
  data() {
    return {
      scheduleBox: [
        '填写投保信息',
        '确认信息并支付',
        '投保成功',
      ],
    };
  },
};

</script>

<style lang="less" scoped>
@import "../assets/less/variable";

#insurance-order-nav {
  width: 1000px;
  margin: 0 auto;

  .bread {
    display: flex;
    align-items: center;
    .bread-ellipsis {
      width: 160px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  .insurance-schedule {
    background-color: @white;
    height: 74px;
    padding: 14px 190px 14px 150px;
    display: flex;
    position: relative;
    justify-content: space-between;
    .schedule-item {
      font-size: 14px;
      color: @text-aaa;
      text-align: center;
      position: relative;
      z-index: 99;
      &.active {
        color: @blue;
        .item-num {
          border-color: @blue;
          background-color: @blue;
          color: @white;
        }
      }
      .item-num {
        width: 24px;
        height: 24px;
        border: 1px solid @text-light-gray;
        line-height: 22px;
        margin: 0 auto 8px;
        border-radius: 50%;
        background-color: @white;
      }
    }
    .schedule-line {
      position: absolute;
      top: 26px;
      left: 214px;
      height: 1px;
      width: 546px;
      border-top: 1px dashed @color-dedede;
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/components/insurance-order-nav.vue